import api from '@/utils/axios';

export const fetchDepartmentsList = async ({
  active = 'all'
} = {}) => {
  const response = await api.get(`departments?active=${encodeURIComponent(active)}`);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch departments');
  }
  return Array.isArray(response.data.data) ? response.data.data : [];
};

export const createDepartment = async (payload) => {
  const response = await api.post('departments/manage', {
    action: 'create',
    ...payload
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to create department');
  }
  return response.data.data;
};

export const updateDepartment = async (payload) => {
  const response = await api.post('departments/manage', {
    action: 'update',
    ...payload
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to update department');
  }
  return response.data.data;
};

export const updateDepartmentStatus = async ({ department_id, is_active }) => {
  const response = await api.post('departments/manage', {
    action: 'update',
    department_id,
    is_active: is_active ? 1 : 0
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to update department status');
  }
  return response.data.data;
};

export const deleteDepartment = async ({ department_id }) => {
  const response = await api.post('departments/manage', {
    action: 'delete',
    department_id
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to delete department');
  }
  return response.data.data;
};

export const fetchDepartmentEditorOptions = async ({ departmentId = null } = {}) => {
  const params = departmentId != null && Number(departmentId) > 0
    ? `?department_id=${encodeURIComponent(String(departmentId))}`
    : '';
  const response = await api.get(`departments/editor-options${params}`);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch department editor options');
  }
  return response.data.data || {
    reporting_executives: [],
    head_candidates: [],
    auto_head: null,
  };
};
